//@ts-ignore
import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll<HTMLElement>('.splide-gallery-inner')
    .forEach((element) => {
      var mainElement = element.querySelector<HTMLElement>('.splide-main');

      if (mainElement) {
        let main = createSplide(mainElement, null);

        var thumbnailsElement = element.querySelector<HTMLElement>('.splide-thumbnails');
        if (thumbnailsElement) {

          let main = createSplide(mainElement, null);
          let thumbnails = createSplide(thumbnailsElement, null);

          main.sync(thumbnails);
          main.mount();
          thumbnails.mount();
        } else {

          main.mount();
        }
      }


    });

  document.querySelectorAll<HTMLElement>('.static-splide')
    .forEach((element) => {
      let splide = createSplide(element, null);
      splide.mount();
    });
});

export function createSplide(element: HTMLElement, options: any) {
  let splide = new Splide(element, options);

  // Helper to pause all videos in a slide
  function pauseVideosInSlide(slideElement: HTMLElement) {
    const videos = slideElement.querySelectorAll<HTMLVideoElement>('video');
    videos.forEach((video) => {
      if (!video.paused) {
        video.pause();
      }
    });
  }

  // Helper to play all videos in a slide (with error handling)
  function playVideosInSlide(slideElement: HTMLElement) {
    const videos = slideElement.querySelectorAll<HTMLVideoElement>('video');
    videos.forEach((video) => {
      video.play().catch((error) => {
        console.warn('Video autoplay failed:', error);
      });
    });
  }

  splide.on('mounted', function () {
    if (splide.length <= 1) {
      splide.options = {
        autoplay: false,
        drag: false,
        arrows: false,
        pagination: false,
      };
    }

    // Play videos on the initial slide after mount
    const initialSlide = splide.Components.Slides.getAt(splide.index)?.slide;
    if (initialSlide) {
      playVideosInSlide(initialSlide);
    }
  });

  splide.on('move', function (newIndex: number, previousIndex: number, destIndex: number) {
    const prevSlide = splide.Components.Slides.getAt(previousIndex)?.slide;
    if (prevSlide) {
      pauseVideosInSlide(prevSlide);
    }
  });

  splide.on('moved', function (newIndex: number, previousIndex: number, destIndex: number) {
    const currSlide = splide.Components.Slides.getAt(newIndex)?.slide;
    if (currSlide) {
      playVideosInSlide(currSlide);
    }
  });

  return splide;
}
